<div class="profile-setup">
  <h2>Set up your profile</h2>

  <form [formGroup]="profileForm" (ngSubmit)="submitProfile()">
    <div class="input_wrapper">
      <label>Create Username</label>
      <input
        type="text"
        formControlName="username"
        autocomplete="off"
        [ngClass]="{ 'input-error': username?.invalid && (username?.dirty || username?.touched) }"
        required
      />

      <div class="info" *ngIf="username?.pending">Checking availability...</div>
      <div *ngIf="username?.invalid && (username?.dirty || username?.touched)">
        <div class="error" *ngIf="username?.errors?.['required']">Username is required.</div>
        <div class="error" *ngIf="username?.errors?.['pattern']">Only A-Z, 0-9, _ and . are allowed.</div>
        <div class="error" *ngIf="username?.errors?.['minlength'] || username?.errors?.['maxlength']">
          Username must be 1 to 25 characters.
        </div>
        <div class="error" *ngIf="username?.errors?.['taken']">Username is already taken.</div>
      </div>
    </div>

    <div class="input_wrapper">
      <label>Email</label>
      <input type="email" formControlName="email">
    </div>

    <div class="avatar_wrapper">
      <div class="avatar-container"
           *ngFor="let avatar of avatars"
           [class.selected]="avatar === selectedAvatar"
           (click)="selectAvatar(avatar)"
      >
        <img
          [src]="'assets/images/avatars/' + avatar" alt="Avatar">
      </div>
    </div>

    <button class="start-btn btn" type="submit" [disabled]="!isFormValid">Start to play</button>
  </form>
</div>
